// eslint-disable-next-line import/prefer-default-export
export const GET_OVERTIME_VOLUNTARY_SUCCESS = 'GET_OVERTIME_VOLUNTARY_SUCCESS';
export const GET_OVERTIME_VOLUNTARY_ERROR = 'GET_OVERTIME_VOLUNTARY_ERROR';
export const GET_OVERTIME_VOLUNTARY_PENDING = 'GET_OVERTIME_VOLUNTARY_PENDING';
export const SET_OVERTIME_VOLUNTARY_DATA = 'SET_OVERTIME_VOLUNTARY_DATA';
export const SAVE_OVERTIME_VOLUNTARY_SUCCESS =
  'SAVE_OVERTIME_VOLUNTARY_SUCCESS';
export const SAVE_OVERTIME_VOLUNTARY_ERROR = 'SAVE_OVERTIME_VOLUNTARY_ERROR';
export const SAVE_OVERTIME_VOLUNTARY_PENDING =
  'SAVE_OVERTIME_VOLUNTARY_PENDING';
